"use strict";
import { Text, UniversalImage } from "ui/src";
import { borderRadii, iconSizes } from "ui/src/theme";
import { OptionItem } from "components/lists/items/OptionItem";
import { TestID } from "test/fixtures/testIDs";
import { uriToHttpUrls } from "utilities/src/format/urls";
import { GoldenBadgeVerified } from "components/BadgeProvider";
export function NFTCollectionOptionItem({ collectionOption, onPress }) {
  const { name, isVerified, imageUrl } = collectionOption;
  return <OptionItem
    image={<UniversalImage
      fallback={<Text color="$neutral1" numberOfLines={1} textAlign="center">
              {name.slice(0, 1)}
            </Text>}
      uri={imageUrl ? uriToHttpUrls(imageUrl)[0] : void 0}
      autoplay={false}
      size={{ width: iconSizes.icon40, height: iconSizes.icon40 }}
      style={{ image: { borderRadius: borderRadii.roundedFull } }}
    />}
    title={name}
    badge={isVerified ? <GoldenBadgeVerified size="$icon.16" /> : void 0}
    testID={TestID.SearchNFTCollectionItem}
    onPress={onPress}
  />;
}
